import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import FirstWinViewButton from './FirstWinViewButton';

const FirstWinViewPicker = (props) => {
  const { pageContentResource } = usePageContentContext();

  return pickFunction(pageContentResource, {
    [fr.relationships.firstWinView.name]: () => {
      return (
        <FirstWinViewButton {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default FirstWinViewPicker;
